const e = "Targetes de segells", a = "Despeses d'enviament", o = "Altres despeses", n = "Cashback", t = "Mètodes de pagament", i = "Pagar", r = "Nivell", s = "Punts", l = "Targeta de fidelització", d = "Recompenses", c = "Descompte", u = "Propina", m = "Total", p = "Subtotal", h = "Lliurat", g = "Preparar", v = "Lliurament", f = "A sala", L = "Emportar", b = "Carregar més", k = "Mantenir", z = "Nom", y = "Cognoms", C = "Correu", T = "Aniversari", A = "Etiquetas", P = "Gènere", S = "Llenguatge", x = "Codi postal", G = "ddd", E = "A domicili", w = "A recollir", D = "Desconegut", O = "Telèfon", q = "Avui", M = "Matí", W = "Dia", F = "Hora", I = "Trucar", R = "Convidat", V = "Inicia sessió o registra't", N = "Uber", H = "Glovo", B = "Deliveroo", U = "Justeat", j = {
  "wallet.loading.errorTitle": "S'ha produït un error",
  "wallet.loading.error": "Torna-ho a descarregar",
  "wallet.loading.android.success": "Desat a Google Wallet",
  "wallet.loading.ios.success": "Desat a Apple Wallet",
  "wallet.loading.ios": "Carregant a Apple Wallet",
  "wallet.loading.android": "Carregant a Google Wallet",
  stampCards: e,
  "stampCard.complete": "Felicitats! Has completat tots els cicles disponibles.",
  "stampCard.cycleEnd": "Has aconseguit un nou premi. Gràcies per visitar-nos!",
  "stampCard.expired": "La targeta ha caducat",
  "stampCard.expirationLabel": "Caducitat:",
  "userOrders.empty": "El teu historial de comandes està buit",
  "userOrders.info": "Selecciona una comanda per veure els detalls del rebut",
  deliveryFee: a,
  defaultFeeName: o,
  "kioskLanding.outOfOrder.title": "Fora de servei",
  "kioskLanding.outOfOrder.subtitle": "No s’accepten comandes en aquest moment. Consulta amb un cambrer per iniciar una comanda.",
  "kioskLanding.language.title": "Seleccioneu un idioma",
  "kioskLanding.service.title": "On vols la teva comanda?",
  "kioskLanding.service.takeaway": "Para llevar",
  "kioskLanding.service.dineIn": "Per emportar",
  "kioskLanding.service.otherLanguages": "Més idiomes",
  "kioskLanding.inactive.title": "Vols continuar la comanda?",
  "kioskLanding.inactive.prelude": "La comanda es cancel·larà automàticament a",
  "kioskLanding.inactive.cancel": "Cancel·lar comanda",
  "kioskLanding.inactive.continue": "Continuar",
  "userGreetings.defaultUnAuthenticatedText": "Inicieu sessió",
  "userGreetings.defaultAuthenticatedText": "Benvingut, *|customer_name|*",
  "viewOrder.cashbackSpent": "{{denomination}} gastats",
  "viewOrder.cashbackObtained": "{{denomination}} obtinguts",
  "orderRecord.anonOrderText": "Actualització manual",
  "myCashback.historyTitle": "Historial de {{denomination}}",
  "myCashback.denomination": "{{denomination}} actual",
  cashback: n,
  "loginPage.prelude": "Has d'estar registrat per veure aquesta pàgina",
  "loginPage.callToAction": "Feu clic aquí per iniciar sessió",
  paymentMethods: t,
  "shopLanding.singleRestaurant.delivery.title": "Per quan vols la teva comanda?",
  "shopLanding.fetchAction.confirmation.accept": "Accept",
  "shopLanding.fetchAction.confirmation.cancel": "Cancel",
  "shopLanding.fetchAction.confirmation.title": "Are you sure?",
  "shopLanding.fetchAction.confirmation.body": "Please confirm this action",
  "shopLanding.fetchAction.2xx.title": "Success",
  "shopLanding.fetchAction.2xx": "{status} Success",
  "shopLanding.fetchAction.3xx.title": "Redirect",
  "shopLanding.fetchAction.3xx": "{status} Redirect",
  "shopLanding.fetchAction.error.title": "Error",
  "shopLanding.fetchAction.error": "{status} Error",
  "shopLanding.loadingRestaurants": "Preparant restaurants",
  "shopLanding.book.confirmation.bookingPolicy.label": "Dono el meu consentiment per al tractament de dades personals",
  "shopLanding.book.error.text": "Alguna cosa ha anat malament. Si us plau torna-ho a intentar després.",
  "shopLanding.book.success.title": "La teva reserva s'ha completat",
  "shopLanding.book.success.text": "La teva reserva s'ha completat",
  "shopLanding.book.confirmation.submit": "Confirmeu",
  "shopLanding.book.confirmation.marketing.label": "Concordo em receber promoções da marca em meu e-mail",
  "shopLanding.book.confirmation.form.observations.placeholder": "Observacions",
  "shopLanding.book.confirmation.form.observations.label": "Observacions",
  "shopLanding.book.confirmation.form.area.placeholder": "Sala 1",
  "shopLanding.book.confirmation.form.area.label": "Seleccioneu l'àrea",
  "shopLanding.book.confirmation.title": "Confirmeu la vostra reserva:",
  "shopLanding.book.listing.submit": "Continuar",
  "shopLanding.book.listing.title": "Reserva a:",
  "shopLanding.book.notMatch.text": "En aquest moment no us podem oferir ubicacions que coincideixin amb les vostres preferències.",
  "shopLanding.book.notMatch.title": "No hi ha localitzacions disponibles",
  "shopLanding.book.reservation.submit": "Busca un restaurant",
  "shopLanding.book.reservation.title": "Fes la teva reserva",
  "shopLanding.book.nOfPeople": "Nº de persones",
  "shopLanding.book": "Llibre",
  "magiclink.tryAgain": "Reintentar",
  "magiclink.email.code.input": "Introdueix el codi",
  "magiclink.email.code.try.again": "Començar de nou",
  "magiclink.email.code.continue": "Continua",
  "magiclink.email.title": "Introdueix el codi que hem enviat al teu correu electrònic",
  "magiclink.email.code.error": "Codi no vàlid",
  "magiclink.email.content": "En breu rebràs al teu correu un enllaç d'accés. Si no el trobeu a la safata d'entrada, reviseu la carpeta d'spam.",
  "payments.engine.7": "Pagar més tard",
  "payments.engine.10": "Targeta, Apple pay o Google Pay",
  "payments.redirect.verifying": "Processant el pagament…",
  "payments.redirect.errorTitle": "No s'ha pogut completar el pagament.",
  "payments.redirect.error": "S'ha produït un error o el pagament s'ha cancel·lat. Torna-ho a provar.",
  "payments.method.5": "Efectiu",
  "payments.method.4": "Bizum",
  "payments.method.3": "Apple pay",
  "payments.method.2": "Google pay",
  "payments.method.1": "Targeta de crèdit",
  "shopLanding.legal.bookingPolicy": "Política de Reserves",
  "shopLanding.legal.cookiesPolicy": "Política de Cookies",
  "shopLanding.legal.privacyPolicy": "Política de Privadesa",
  "shopLanding.legal.termsAndConditions": "Termes i Condicions de Compra",
  payLink: i,
  "loyaltyCard.disabled": "La targeta de fidelització no està disponible en aquests moments",
  tier: r,
  points: s,
  loyaltyCard: l,
  vouchers: d,
  "weekdays.short.monday": "Dilluns",
  "weekdays.short.tuesday": "Dimarts",
  "weekdays.short.wednesday": "Dimecres",
  "weekdays.short.thursday": "Dijous",
  "weekdays.short.friday": "Divendres",
  "weekdays.short.saturday": "Dissabte",
  "weekdays.short.sunday": "Diumenge",
  "voucher.expiredBurnBtnText": "Oferta no disponible",
  "voucher.burnBtnText": "Marcar cupó com a usat",
  "voucher.terms.scheduleAllDays": "Cada dia",
  "voucher.terms.schedule": "Horario",
  "voucher.terms.usesTimeframe.43200": "s'utilitza cada 12 hores",
  "voucher.terms.usesTimeframe.86400": "usos quotidians",
  "voucher.terms.usesTimeframe.604800": "usos setmanals",
  "voucher.terms.usesTimeframe.2592000": "usos mensuals",
  "voucher.terms.maximum": "Màxim:",
  "voucher.terms.usesTotal": "Usos totals",
  "voucher.terms.usesAndLimitations": "Usos i limitacions",
  "terms.title": "Termes i Condicions",
  "voucher.error.noMoreUses": "Sem usos restants",
  "voucher.error.outOfSchedule": "Fora d'horari",
  "voucher.error.nextActivation": "Propera activació",
  "addToWallet.android": "Google Wallet",
  "addToWallet.apple": "Afegeix a Apple Wallet",
  "voucher.unlimited": "Il·limitat",
  "voucher.validFromTitle": "Vàlid des de",
  "voucher.validUntilTitle": "Vàlid fins",
  "voucher.remainingUsesTitle": "Usos restants",
  "voucher.pendingValidation": "Compte pendent de verificació",
  "voucher.verify": "Verificar",
  "ticket.placed": "Creat",
  "ticket.followOrderBtn": "Seguiu la vostra comanda",
  discount: c,
  tip: u,
  total: m,
  subtotal: p,
  "order.status.unconfirmed": "No confirmat",
  "order.status.confirmed": "Confirmat",
  "order.status.ready": "A punt",
  "order.status.onroute": "De camí",
  "order.status.completed": "Completat",
  "order.status.cancelled": "Cancel·lat",
  order_delivered: h,
  order_preparation: g,
  order_deliver: v,
  dinein: f,
  takeaway: L,
  loadMore: b,
  "userOrders.heading": "Historial de comandes",
  "userProfile.emptyTagsText": "Encara no tens cap etiqueta! Feu clic aquí per afegir-ne un",
  "gender.male": "Mascle",
  "gender.female": "Femella",
  "gender.other": "Altres",
  "gender.na": "N/A",
  "userProfile.editInfoHeading": "Edita la teva informació",
  save: k,
  name: "Nom",
  surname: y,
  email: C,
  birthday: T,
  tags: A,
  gender: P,
  language: S,
  postCode: x,
  "userProfile.navigation.profile": "Perfil",
  "navigation.back": "Tornar",
  "shopLanding.address.error.unknown": "Hi ha hagut un error. Si us plau, intenta-ho més tard",
  "shopLanding.address.error.locationTemporarilyUnavailable": "Ho sentim, aquest servei no està disponible en aquest moment",
  "shopLanding.address.error.addressBothEmpty": "Si us plau, omple els camps direcció i pis/porta",
  "shopLanding.address.error.addressEmpty": "Si us plau, omple el camp direcció",
  "shopLanding.address.error.addressInfoEmpty": "Si us plau, omple el camp pis/porta",
  "shopLanding.singleRestaurant.eta.time": "{{time}} min",
  "shopLanding.singleRestaurant.eta": "Temps de preparació estimat:",
  "shopLanding.redirection.title": "Enhorabona!",
  "shopLanding.redirection": "T'estem redirigint perquè puguis fer la teva comanda",
  "shopLanding.noReach.title": "No arribem a la teva zona",
  testDoNotTouch: "ddd",
  "userMenu.showProfile": "Mostrar perfil ",
  "userMenu.logout": "Tancar sessió",
  "autocomplete.label": "Direcció",
  "autocomplete.placeholder": "Introdueix adreça incloent número",
  "autocomplete.geolocation": "Utilitzar la meva ubicació actual",
  "shopLanding.address.title": "Des d'on demanes?",
  "shopLanding.address.label": "Pis, porta...",
  "shopLanding.address.placeholder": "Especifica l'adreça a domicili o escriu un espai si no s'aplica",
  "shopLanding.address.error.suspended": "Ho sentim, ara mateix no podem acceptar més comandes. Si us plau, torna a intentar-ho en 20 minuts. Moltes gràcies!",
  "shopLanding.address.error.outOfRange": "Ops... en aquest moment no arribem a la teva zona. Pots fer una comanda per recollir al teu restaurant més proper!",
  "shopLanding.address.error.cannotDeliver": "Ho sentim, en aquest moment no podem fer el lliurament a la teva adreça. Et recomanem que facis la comanda per recollir.",
  "shopLanding.address.error.invalidAddress": "Ho sentim, la direcció no és vàlida. Si us plau, comprova-la i torna a introduir-la.",
  "shopLanding.address.error.missingStreet": "Si us plau, introdueix el número del carrer",
  "shopLanding.address.error.orderThrough": "O demana a través de:",
  "shopLanding.selector.title": "Recull la teva comanda a: ",
  "shopLanding.selector.laterBtn": "Demana per més tard",
  "shopLanding.selector.nowBtn": "Demana ara",
  "shopLanding.selector.doOrder": "Fer comanda",
  "shopLanding.datetime.title": "Trieu una hora:",
  "shopLanding.datetime.dayPlaceholder": "Selecciona un dia.",
  "shopLanding.datetime.hourPlaceholder": "Selecciona una hora.",
  "shopLanding.datetime.cancelBtn": "Cancel·la",
  "shopLanding.datetime.programBtn": "Programar",
  "shopLanding.singleRestaurant.title": "T'atendrà el local:",
  delivery: E,
  pickup: w,
  unknown: D,
  phone: O,
  today: q,
  tomorrow: M,
  day: "Dia",
  hour: F,
  call: I,
  guest: R,
  loginText: V,
  uber: N,
  glovo: H,
  deliveroo: B,
  justeat: U,
  "phoneVerification.title": "Verifica el teu número de telèfon",
  "phoneVerification.subtitle": "Rebràs el codi per SMS al número {{phoneNumber}}",
  "phoneVerification.countdown": "Si no arriba, pots sol·licitar un altre codi en {{time}}",
  "phoneVerification.resend": "Sol·licitar un altre codi",
  "phoneVerification.back": "Enrere",
  "phoneVerification.continue": "Continua",
  "phoneVerification.error": "Codi no vàlid",
  "phoneVerification.error.invalidCode": "El codi introduït no és vàlid. Torna-ho a intentar.",
  "phoneVerification.error.expired": "El codi ha caducat. Si us plau, sol·licita'n un de nou.",
  "phoneVerification.error.alreadyUsed": "Aquest codi ja ha estat utilitzat. Si us plau, sol·licita'n un de nou.",
  "phoneVerification.error.attemptsExceeded": "Massa intents incorrectes. Si us plau, sol·licita un nou codi.",
  "phoneVerification.error.generic": "Alguna cosa ha anat malament. Si us plau, torna-ho a intentar.",
  "phoneInputForm.error.otpRequestCooldown": "Si us plau, espera abans de sol·licitar un nou codi.",
  "phoneInputForm.error.otpRateLimit": "Massa sol·licituds. Si us plau, torna-ho a intentar més tard.",
  "phoneInputForm.error.smsProviderError": "No hem pogut enviar el SMS. Si us plau, torna-ho a intentar.",
  "phoneInputForm.title": "Introdueix el teu número de telèfon",
  "phoneInputForm.phoneLabel": "Telèfon",
  "phoneInputForm.back": "Enrere",
  "phoneInputForm.continue": "Continua",
  "duplicatePhoneError.title": "Ja existeix un usuari amb aquest número vinculat",
  "duplicatePhoneError.subtitle": "El número de telèfon del teu compte ja està registrat per un altre usuari a la plataforma. Inicia sessió amb el correu associat.",
  "duplicatePhoneError.back": "Tornar"
};
export {
  T as birthday,
  I as call,
  n as cashback,
  W as day,
  j as default,
  o as defaultFeeName,
  B as deliveroo,
  E as delivery,
  a as deliveryFee,
  f as dinein,
  c as discount,
  C as email,
  P as gender,
  H as glovo,
  R as guest,
  F as hour,
  U as justeat,
  S as language,
  b as loadMore,
  V as loginText,
  l as loyaltyCard,
  z as name,
  v as order_deliver,
  h as order_delivered,
  g as order_preparation,
  i as payLink,
  t as paymentMethods,
  O as phone,
  w as pickup,
  s as points,
  x as postCode,
  k as save,
  e as stampCards,
  p as subtotal,
  y as surname,
  A as tags,
  L as takeaway,
  G as testDoNotTouch,
  r as tier,
  u as tip,
  q as today,
  M as tomorrow,
  m as total,
  N as uber,
  D as unknown,
  d as vouchers
};
//# sourceMappingURL=translation.json.js.map
